import { useEffect } from "react";
import "./_NewsModal.scss";

const getCategoryStyle = (category) => {
    const normalizedCategory = category?.trim() || "公告";
    switch (normalizedCategory) {
        case "賽事":
            return {
                background: "linear-gradient(135deg, #d97706 0%, #b45309 100%)", // Amber
            };
        case "優惠":
            return {
                background: "linear-gradient(135deg, #db2777 0%, #be185d 100%)", // Pink
            };
        case "公告":
            return {
                background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)", // Blue
            };
        case "重要":
            return {
                background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)", // Red
            };
        default:
            return {
                background: "linear-gradient(135deg, #4b5563 0%, #374151 100%)", // Gray
            };
    }
};

function NewsModal({ isOpen, onClose, news }) {
    // 當 modal 開啟時，防止背景滾動
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }

        return () => {
            document.body.style.overflow = "unset";
        };
    }, [isOpen]);

    // 按 ESC 鍵關閉
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        if (isOpen) {
            window.addEventListener("keydown", handleEsc);
        }

        return () => {
            window.removeEventListener("keydown", handleEsc);
        };
    }, [isOpen, onClose]);

    if (!isOpen || !news) return null;

    const headerStyle = getCategoryStyle(news.category);

    return (
        <div className="news-modal-overlay" onClick={onClose}>
            <div className="news-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="news-modal-close" onClick={onClose} aria-label="關閉">
                    ×
                </button>
                <div className="news-modal-header" style={headerStyle}>
                    <div className="news-modal-meta">
                        <span className="news-modal-tag">{news.category || "公告"}</span>
                        <span className="news-modal-date">{news.date}</span>
                    </div>
                    <h3>{news.title}</h3>
                </div>
                <div className="news-modal-body">
                    <p>{news.content}</p>
                </div>
            </div>
        </div>
    );
}

export default NewsModal;
